import React from 'react';
import { StyledTitle } from './HeaderStyling';

const Header = () => {
  return (
    <StyledTitle>Welcome to the Labyrinth</StyledTitle>
  )
};

export default Header;